import React from 'react'
import PropTypes from 'prop-types'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  ResponsiveBreakpointsProvider,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'
import useResponsiveBreakpointsRollout, {
  RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS
} from 'utils/hooks/useResponsiveBreakpointsRollout'

const DISPLAY_CONTENTS_STYLE = Object.freeze({ display: 'contents' })

const AppShellVersionMarker = ({ children, isPending }) => {
  const version = useResponsiveBreakpointsVersion()

  return (
    <div
      aria-busy={isPending || undefined}
      data-responsive-breakpoints={version}
      data-responsive-breakpoints-page={RESPONSIVE_BREAKPOINT_PAGES.APP_SHELL}
      data-responsive-breakpoints-status={isPending ? 'pending' : undefined}
      style={DISPLAY_CONTENTS_STYLE}
    >
      {children}
    </div>
  )
}

AppShellVersionMarker.propTypes = {
  children: PropTypes.node.isRequired,
  isPending: PropTypes.bool.isRequired
}

const AppShellWithRollout = ({ children }) => {
  const rolloutStatus = useResponsiveBreakpointsRollout(
    RESPONSIVE_BREAKPOINT_PAGES.APP_SHELL
  )
  const isPending =
    rolloutStatus === RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS.PENDING
  const version = isPending
    ? RESPONSIVE_BREAKPOINT_VERSIONS.LEGACY
    : rolloutStatus

  return (
    <ResponsiveBreakpointsProvider value={version}>
      <AppShellVersionMarker isPending={isPending}>
        {children}
      </AppShellVersionMarker>
    </ResponsiveBreakpointsProvider>
  )
}

AppShellWithRollout.propTypes = {
  children: PropTypes.node.isRequired
}

export default AppShellWithRollout
